import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import ExtraBold from "./TicketExtraBold.woff2";

export const TicketExtraBoldFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: ExtraBold },
];
